import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Typography } from '@mui/material'
import { SparkDataTable } from 'sharedComponents/UI'
import { Column } from 'sharedComponents/UI/SparkDataTable'
import { EditIcon, SBFaceRound } from 'components/SVG'

type AdminAccountListRow = {
  id: string
  email: string
  name: string
  surname: string
  lastActivity: string
}

function AdminAccountList() {
  const navigate = useNavigate()

  const columns: Column<AdminAccountListRow>[] = [
    {
      field: 'email',
      headerText: 'Email',
      sortable: true,
      cellRenderer: (row) => (
        <Box
          display='flex'
          alignItems='center'
          gap={2}
          flex={1}
        >
          <SBFaceRound
            width='35px'
            height='35px'
          />
          <Typography>email@gmail.com</Typography>
        </Box>
      ),
    },
    {
      field: 'name',
      headerText: 'Name',
      sortable: true,
      cellRenderer: (row) => (
        <Box
          display='flex'
          alignItems='center'
          gap={2}
          flex={1}
        >
          <Typography>Jaco</Typography>
        </Box>
      ),
    },
    {
      field: 'surname',
      headerText: 'Surname',
      sortable: true,
      cellRenderer: (row) => (
        <Box
          display='flex'
          alignItems='center'
          gap={2}
          flex={1}
        >
          <Typography>Gerrits</Typography>
        </Box>
      ),
    },
    {
      field: 'lastActivity',
      headerText: 'Last Activity',
      sortable: true,
      cellRenderer: (row) => (
        <Box
          display='flex'
          alignItems='center'
          gap={2}
          flex={1}
        >
          <Typography>21 Sep 2023, 10:32:12am</Typography>
        </Box>
      ),
    },
  ]

  const rows: AdminAccountListRow[] = [
    {
      id: '1',
      email: 'email@gmail.com',
      name: 'Jaco',
      surname: 'Gerrits',
      lastActivity: '21 Sep 2023, 10:32:12am',
    },
    {
      id: '2',
      email: 'email@gmail.com',
      name: 'Jaco',
      surname: 'Gerrits',
      lastActivity: '21 Sep 2023, 10:32:12am',
    },
  ]

  return (
    <SparkDataTable<AdminAccountListRow>
      columns={columns}
      rows={rows}
      onRowClick={(rowID) => navigate(``)}
    />
  )
}

export default AdminAccountList
